const config = {
    contentful: {
        space: 'j1q40q0b1tdb',
        environment: 'master',
        accessToken: 'ALLtRZrDJsk3ibrhxrm2p6JXJ2FfQtXfxECQboKe5D0'
    }
}
export default config;
